import { render, staticRenderFns } from "./InspectorManage.vue?vue&type=template&id=746efa6e&scoped=true"
import script from "./InspectorManage.vue?vue&type=script&lang=js"
export * from "./InspectorManage.vue?vue&type=script&lang=js"
import style0 from "./InspectorManage.vue?vue&type=style&index=0&id=746efa6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746efa6e",
  null
  
)

export default component.exports